<template>
  <div class="app-main-inner-row">
    <div class="accounting-document-form" :style="formWidth">
      <div class="accounting-document-form-title">
        <div class="left">
          <el-select ref="fpSelect" v-model="fiscalPeriodUuid" no="1" style="width: 110px;margin-right: 5px" :disabled="fpSelectDisabled" @change="fiscalPeriodChangeHandler">
            <el-option
              v-for="(item,index) in fpSelectDataProvider"
              :key="index"
              :label="fiscalPeriodLabelFun(item)"
              :value="item.uuid"
            />
          </el-select>
          {{ $t('CargoMsg.Cargo_Date') }}
          <el-date-picker ref="documentDateDF" v-model="voucher.documentDate" no="2" style="width: 130px;margin-right: 5px" type="date" value-format="yyyy-MM-dd" />
          {{ $t('CargoMsg.Cargo_VoucherLetter') }}
          <el-select v-if="!voucher.isZhuan" v-model="voucher.prefix" no="3" style="width: 100px;margin-right: 5px">
            <el-option v-for="(item,index) in prefixDDL" :key="index" :label="item.label" :value="item.value" />
          </el-select>
          <el-input v-if="voucher.isZhuan" v-model="voucher.prefix" no="4" style="width: 55px" />
          <el-input v-model="voucher.documentNo" no="5" style="width: 55px" />{{ $t('CargoMsg.Cargo_NumberS') }}
        </div>
        <div class="center">{{ $t('CargoMsg.Cargo_BookKeepingVoucher') }}</div>
        <div class="right">
          {{ $t('CargoMsg.Cargo_AttachedDocuments') }}
          <el-input-number v-model="voucher.sourceDocument" no="6" :controls="false" style="width: 55px" />{{ $t('CargoMsg.Cargo_Page') }}
        </div>
      </div>
      <div class="accounting-document-form-table">
        <accounting-document-grid ref="grid" :type="type" :row-data="voucher.accountingEntry" :account-set="accountSet" :fiscal-period="voucherFiscalPeriod" @changeWidth="changeWidthHandler" />
      </div>
      <div class="accounting-document-form-footer">
        <div v-if="voucherList && type !== 'copy'" class="accounting-document-form-footer-button">
          <el-button no="7" type="primary" size="mini" @click="changeVoucherIndex(0)">{{ $t('CargoMsg.Cargo_1St') }}</el-button>
          <el-button no="8" type="primary" size="mini" @click="changeVoucherIndex(curVoucherIndex-1)">{{ $t('CargoMsg.Cargo_TheLastPage') }}</el-button>
          <el-button no="9" type="primary" size="mini" @click="changeVoucherIndex(curVoucherIndex+1)">{{ $t('CargoMsg.Cargo_TheNextPage') }}</el-button>
          <el-button no="10" size="mini" type="primary" @click="changeVoucherIndex(voucherList.length-1)">{{ $t('CargoMsg.Cargo_TheLast') }}</el-button>
        </div>
        <span>{{ $t('CargoMsg.Cargo_PreparedByP') }}{{ documentMakerStr }}</span>
        <span v-show="voucher.dateModified">{{ $t('CargoMsg.Cargo_LastModificationTime') }}{{ voucher.dateModified }}</span>
        <span v-show="!voucher.dateModified" />
      </div>
    </div>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="this"
    />
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import AccountingDocumentGrid from '@/views/cargo/v0/FinanceManage/AccountingDocument/components/AccountingDocumentGrid'
import VoucherUtils from '@/utils/VoucherUtils'
import * as accountingDocumentApi from '@/api/financeManage/accountingDocument'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import DateUtils from '@/utils/dateUtils'
import * as fiscalPeriodApi from '@/api/financeManage/fiscalPeriod'
import * as accountingDocumentTypeApi from '@/api/financeManage/accountingDocumentType'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth'
import moment from 'moment'
import { getLoading } from '@/utils/utilBaseElement'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'AccountingDocumentForm',
  components: { AccountingDocumentGrid, cargoTemplateSelectorDialog },
  props: {
    type: {
      type: String,
      default: 'add'
    },
    accountSet: { type: Object, default: null },
    voucherList: { type: Array, default: () => [] },
    voucherIndex: { type: Number, default: () => 0 }
  },
  data() {
    return {
      TYPE_NAMES: TYPE_NAMES,
      ColumnUtils: ColumnUtils,
      // currentVoucherList: [],
      prefixDDL: [],
      curVoucherIndex: 0,
      loading: false,
      voucher: {
        uuid: '',
        isZhuan: false,
        fiscalPeriod: '',
        documentDate: moment().format('yyyy-MM-DD'),
        prefix: LocalStorageUtilsNew.getConfiguration('AccountingDocumentForm_vocherPrefix', 'string') || '收',
        documentNo: '',
        sourceDocument: '',
        accountingEntry: [],
        documentMaker: this.$store.getters.userId,
        dateModified: '',
        audited: false,
        verifier: 0
      },
      accountingDocument: null,
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      lastSaveFP: null,
      saveAndAdd: false,
      nonCloseFiscalPeriodCollection: null,
      fpSelectDataProvider: null,
      fiscalPeriodUuid: '',
      formWidth: '1140px'
    }
  },
  computed: {
    documentMakerStr() {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', this.voucher.documentMaker, 'chineseName')
    },
    voucherFiscalPeriod() {
      if (!this.voucher.fiscalPeriod) {
        return {}
      } else {
        return this.voucher.fiscalPeriod
      }
    },
    fpSelectDisabled() {
      return this.voucher.uuid !== ''
    }
  },
  watch: {
    async accountSet(newVal) {
      const prefixDDL = [
        { value: '收', label: this.$t('FinanceManage.Receive') },
        { value: '付', label: this.$t('FinanceManage.Pay') },
        { value: '转', label: this.$t('FinanceManage.Transfer') },
        { value: '*', label: '*' }
      ]
      const prefixDDLValues = Array.from(prefixDDL, p => p.value)
      if (newVal) {
        this.create()
        this.refreshFPSelect()
        if (this.type === 'add') {
          // this.voucherList = [] // await accountingDocumentApi.query({ accountingSetKey: this.accountSet.uuid }).then(resp => resp.data.list)
        }
        if (newVal.uuid) {
          await accountingDocumentTypeApi.query({ accountingSetKey: newVal.uuid }).then(res => {
            const uniqueSet = new Set()
            for (const row of res.data.list) {
              if (row.prefix && !prefixDDLValues.includes(row.prefix)) {
                uniqueSet.add(row.prefix)
              }
            }
            if (uniqueSet.size > 0) {
              for (const item of uniqueSet) {
                prefixDDL.push({ value: item, label: item })
                prefixDDLValues.push(item)
              }
            }
          }).catch(() => {})
        }
      }
      this.prefixDDL = prefixDDL
      if (this.voucher && !prefixDDLValues.includes(this.voucher.prefix)) {
        this.voucher.prefix = '收'
      }
    },
    voucher(newVal) {
      if (newVal && newVal.accountingEntry) {
        for (const entry of newVal.accountingEntry) {
          entry.debitCrebit = isNaN(entry.debitCrebit) ? 0 : entry.debitCrebit
          entry.crebitAmount = isNaN(entry.crebitAmount) ? 0 : entry.crebitAmount
          if (entry.debitCrebit) {
            entry.debitAmount = entry.amount
            entry.crebitAmount = 0
          } else {
            entry.debitAmount = 0
            entry.crebitAmount = entry.amount
          }
        }
      }
      if (newVal) {
        if (this.fpSelectDataProvider) {
          const currentFp = this.fpSelectDataProvider.find(fp => fp.month === newVal.month && fp.year === newVal.year)
          if (currentFp) {
            newVal.fiscalPeriod = currentFp
          }
        }
      }
    }
  },
  async created() {
    // if (this.voucherList) {
    //   this.currentVoucherList = this.voucherList
    // }
    if (this.voucherIndex) {
      this.curVoucherIndex = this.voucherIndex
    }
    if (this.voucherList && !['add', 'copy'].includes(this.type)) {
      this.voucher = await this.getVoucher()
      await this.refreshFPSelect()
      const currentFp = this.fpSelectDataProvider.find(fp => fp.month === this.voucher.month && fp.year === this.voucher.year)
      if (currentFp) {
        this.fiscalPeriodUuid = currentFp.uuid
        this.voucher.fiscalPeriod = currentFp
      }
    } else if (this.type === 'copy') {
      this.voucher = await this.getVoucher()
      this.voucher.documentNo = ''
      this.voucher.uuid = ''
      this.voucher.documentDate = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
      await this.refreshFPSelect()
      const currentFp = this.fpSelectDataProvider.find(fp => fp.month === this.voucher.month && fp.year === this.voucher.year)
      if (currentFp) {
        this.fiscalPeriodUuid = currentFp.uuid
        this.voucher.fiscalPeriod = currentFp
      }
    }
    EventBus.$emit('voucherChanged', this.voucher)
    EventBus.$on('accountingDocumentSaveAndAdd', this.saveAndAddHandler)
    EventBus.$on('accountingDocumentSave', this.saveHandler)
    EventBus.$on('accountingDocumentAccept', this.accept)
    EventBus.$on('accountingDocumentReject', this.reject)
    EventBus.$on('accountingDocumentDeleted', this.delete)
    EventBus.$on('accountingDocumentPrint', this.print)
    EventBus.$on('accountingDocumentCancel', this.cancel)
    await cache.load(cacheName.CONFIG)
  },
  beforeDestroy() {
    if (this.voucher) {
      LocalStorageUtilsNew.setConfiguration('AccountingDocumentForm_vocherPrefix', this.voucher.prefix)
    }
    EventBus.$off()
  },
  methods: {
    async changeVoucherIndex(index) {
      if (this.voucherList.length === 0) return
      if (index < 0) {
        this.curVoucherIndex = 0
      } else if (index > this.voucherList.length - 1) {
        this.curVoucherIndex = this.voucherList.length - 1
      } else {
        this.curVoucherIndex = index
      }
      this.voucher = await this.getVoucher()
      EventBus.$emit('voucherChanged', this.voucher)
    },
    async getVoucher() {
      const voucher = this.voucherList[this.curVoucherIndex]
      if (voucher) {
        return await accountingDocumentApi.detail({ uuid: voucher.uuid }).then(resp => resp.data)
      }
      return null
    },
    // 保存并新增
    saveAndAddHandler() {
      console.log('保存并新增')
      EventBus.$emit('voucherChanged', this.voucher)
      this.saveAndAdd = true
      this.clickHandler2()
    },
    // 保存
    saveHandler() {
      console.log('保存')
      EventBus.$emit('voucherChanged', this.voucher)
      this.saveAndAdd = false
      this.clickHandler2()
    },
    // 提示本位币金额不等于原币*汇率,是否可以保存
    async clickHandler2() {
      // 保存凭证时，去掉原币×汇率不能为 0的强制要求，改为提示。这样就支持手工录入期末调汇凭证
      if (this.$refs.grid.validateLocalAmount()) {
        await this.$confirm(this.$t('CargoMsg.Cargo_AILCNETOCERCTS'))
      }
      this.clickHandler()
    },
    clickHandler() {
      this.loading = getLoading()
      if (!this.validateForm()) {
        this.loading.close()
        return
      }
      const accountingDocument = this.$refs.grid.accountingDocument
      if (accountingDocument) {
        // 凭证字
        accountingDocument.prefix = this.voucher.prefix
        // 凭证号
        accountingDocument.documentNo = !StrUtils.isEmpty(this.voucher.documentNo) ? this.voucher.documentNo : 1
        // 日期
        accountingDocument.documentDate = this.voucher.documentDate
        // 附单据数量
        accountingDocument.sourceDocument = Number(this.voucher.sourceDocument)
        // 年
        accountingDocument.year = Number(this.voucher.fiscalPeriod.year)
        // 期
        accountingDocument.month = Number(this.voucher.fiscalPeriod.month)
        // 制单人
        if (!accountingDocument.uuid) {
          accountingDocument.documentMaker = this.$store.getters.userId
        }

        this.$refs.grid.retrieveEntry()
        if (!accountingDocument.accountingEntry || accountingDocument.accountingEntry.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PEALTVJE'))
          this.loading.close()
          return
        }
        this.$refs.grid.retrieveDebitCreditTotal()
        if (this.saveAndAdd) {
          this.lastSaveFP = this.voucher.fiscalPeriod
        } else {
          this.lastSaveFP = null
        }
        if (this.type === 'edit') {
          accountingDocument.uuid = this.voucher.uuid
        }
        // 复制的数据，把原数据关联清空
        if (this.type === 'copy') {
          accountingDocument.uuid = ''
          if (accountingDocument.accountingEntry) {
            for (const ad of accountingDocument.accountingEntry) {
              ad.uuid = ''
              ad.accountingDocumentUuid = ''
            }
          }
        }
        accountingDocumentApi.save(accountingDocument).then(resp => {
          this.saveSuccessHandler(resp)
          if (!this.saveAndAdd) {
            this.voucher.uuid = resp.data.uuid
            this.voucher.documentNo = resp.data.documentNo
            // const accountTitleMap = new Map()
            // if (this.voucher.accountingEntry && this.voucher.accountingEntry.length > 0) {
            //   for (const entry of this.voucher.accountingEntry) {
            //     console.log('entry.accountTitle============', )
            //     accountTitleMap.set(entry.accountTitle, entry.accountTitleColumn)
            //   }
            // }
            // console.log('accountTitleMap===============', accountTitleMap)
            if (resp.data && resp.data.accountingEntry && resp.data.accountingEntry.length > 0) {
              const accountTitleCollection = this.accountSet.accountTitle
              for (const entry of resp.data.accountingEntry) {
                entry.accountTitleColumn = ColumnUtils.accountTitleColumnLabelFunc(accountTitleCollection, entry)
                if (entry.debitCrebit) {
                  entry.debitAmount = entry.amount
                  entry.crebitAmount = 0
                } else {
                  entry.debitAmount = 0
                  entry.crebitAmount = entry.amount
                }
              }
            }
            Object.assign(this.voucher, resp.data)
          }
          if (this.type === 'copy') {
            this.cancel()
          }
        }).finally(() => {
          this.loading.close()
        })
        // accountingDocument.save2(accountingDocumentResultHandler, accountingDocumentFaultHandler)
      }
    },
    saveSuccessHandler(resp) {
      this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      if (this.saveAndAdd) {
        this.voucher = {
          uuid: '',
          isZhuan: false,
          fiscalPeriod: '',
          documentDate: moment().format('yyyy-MM-DD'),
          prefix: this.voucher.prefix || '收',
          documentNo: '',
          sourceDocument: '',
          accountingEntry: [],
          documentMaker: this.$store.getters.userId,
          dateModified: '',
          audited: false,
          verifier: 0
        }
        this.voucher.accountSetUuid = this.accountSet.uuid
        this.voucher.businessDataType = 999
        this.voucher.sourceDocument = '0'
        this.voucher.updateDate = ''
        this.voucher.documentNo = ''
        // CARGO-23539，凭证录入，点保存新增之后就空白没有格子
        for (let i = 0; i < 4; i++) {
          const rowItem = {
            index: Math.floor(Math.random() * 1000),
            summary: '',
            accountTitle: '',
            debitAmount: 0,
            crebitAmount: 0,
            amount: 0,
            exchangeRate: 0,
            sourceAmount: 0,
            sourceCurrency: ''
          }
          this.voucher.accountingEntry.push(rowItem)
        }
        // CARGO-26483 【凭证录入】-录入信息点"保存并新增"后，选择相同的会计科目缺只能看到一个币种
        this.refreshFPSelect()
        this.$refs.grid.accountingDocument = this.voucher
        fiscalPeriodApi.getCurrentFiscalPeriod({ 'accountingSetKey': this.accountSet.uuid }).then(resp => {
          this.getCurrentFiscalPeriodResultHandler(resp)
        })
      } else {
        // currentState = EDITSTATE;
      }
    },
    getCurrentFiscalPeriodResultHandler(resp) {
      if (!resp.data) {
        this.$message.warning(this.$t('FinanceManage.FailedObtainCurrentFiscalPeriod'))
        return
      }
      this.currentFiscalPeriod = resp.data
    },
    getCurrentFiscalPeriodHandler(value) {
      var fiscalPeriod = value
      if (fiscalPeriod && (!this.voucher || !this.voucher.uuid)) {
        this.refreshFPSelect()
        if (this.lastSaveFP) {
          this.voucher.fiscalPeriod.year = this.lastSaveFP.year
          this.voucher.fiscalPeriod.month = this.lastSaveFP.month
        } else {
          this.voucher.fiscalPeriod.year = fiscalPeriod.year
          this.voucher.fiscalPeriod.month = fiscalPeriod.year
        }
        const date = new Date()
        DateUtils.customFormat(date, 'YYYY-MM-dd')
        this.voucher.documentDate = DateUtils.customFormat(date, 'YYYY-MM-dd')
      }
      if (!this.voucher || !this.voucher.uuid) {
        this.create()
      } else {
        this.$refs.grid.accountingDocument = this.voucher

        // 凭证字
        if (this.$refs.grid.accountingDocument.businessDataType === 999) {
          this.isZhuan = false
        } else {
          this.isZhuan = true
        }
        // 凭证号
        this.voucher.documentNo = this.voucher.documentNo.toString()
        // 附单据数量
        this.voucher.sourceDocument = this.voucher.sourceDocument.toString()
        this.refreshFPSelect()
        this.voucher.fiscalPeriod.year = this.$refs.grid.accountingDocument.year
        this.voucher.fiscalPeriod.month = this.$refs.grid.accountingDocument.month

        this.voucher.updateDate = this.getDateModified() ? this.$t('CargoMsg.Cargo_LastModificationTime') + DateUtils.customFormat(DateUtils.dateToStr(this.getDateModified()), 'yyyy-MM-dd HH:mm:ss') : ''
      }
      if (this.voucher.fiscalPeriod) {
        this.$refs.fpSelect.focus()
      } else {
        this.$refs.documentDateDF.focus()
      }
    },
    create() {
      if (!this.voucher) {
        this.voucher = {
          uuid: '',
          isZhuan: false,
          fiscalPeriod: '',
          documentDate: moment().format('yyyy-MM-DD'),
          prefix: '收',
          documentNo: '',
          sourceDocument: '',
          accountingEntry: [],
          documentMaker: this.$store.getters.userId,
          dateModified: '',
          audited: false,
          verifier: 0
        }
      }
      this.voucher.accountSetUuid = this.accountSet.uuid
      this.voucher.businessDataType = 999
      this.voucher.sourceDocument = '0'
      this.voucher.updateDate = ''
      this.voucher.documentNo = ''
      this.$refs.grid.accountingDocument = this.voucher
    },
    async refreshFPSelect() {
      if (!this.voucher || !this.voucher.uuid) {
        if (!this.nonCloseFiscalPeriodCollection || this.nonCloseFiscalPeriodCollection.length === 0) {
          const params = {}
          params.accountingSetKey = this.accountSet.uuid
          params.closing = 0
          this.nonCloseFiscalPeriodCollection = this.accountSet.nonCloseFiscalPeriod // await fiscalPeriodApi.query(params).then(resp => resp.data.list)
        }
        this.fpSelectDataProvider = this.nonCloseFiscalPeriodCollection
        if (this.nonCloseFiscalPeriodCollection && this.nonCloseFiscalPeriodCollection.length > 0) {
          this.voucher.fiscalPeriod = this.nonCloseFiscalPeriodCollection[0]
        }
      } else {
        this.fpSelectDataProvider = this.accountSet.fiscalPeriod // await fiscalPeriodApi.query({ accountingSetKey: this.accountSet.uuid }).then(resp => resp.data.list)
      }
      if (this.fpSelectDataProvider && this.fpSelectDataProvider.length > 0) {
        this.fiscalPeriodUuid = this.fpSelectDataProvider[0].uuid
      }
    },
    getDateModified() {
      var adDate = this.voucher.dateModified
      var aeDate
      for (var ae of this.voucher.accountingEntry) {
        aeDate = ae.dateModified > aeDate ? ae.dateModified : aeDate
      }
      return adDate.getTime() > aeDate.getTime() ? adDate : aeDate
    },
    validateForm() {
      if (!this.voucher.documentDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DateCanTBeEmpty'))
        return false
      }
      const year = DateUtils.dateToStr(this.voucher.documentDate).getFullYear()
      const month = DateUtils.dateToStr(this.voucher.documentDate).getMonth() + 1
      if (VoucherUtils.checkVoucherDateClosing(year, month, this.fpSelectDataProvider)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SVSFPHBC'))
        return false
      }
      if (this.voucher.fiscalPeriod && (moment(this.voucher.documentDate).format('yyyy-MM-DD') < moment(this.voucher.fiscalPeriod.beginDate).format('yyyy-MM-DD') ||
        moment(this.voucher.documentDate).format('yyyy-MM-DD') > moment(this.voucher.fiscalPeriod.endDate).format('yyyy-MM-DD'))) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DateNotInPeriod'))
        return false
      }
      if (this.voucher.uuid) {
        if (!this.voucher.isZhuan && this.voucher.documentNo === '') {
          this.$message.warning(this.$t('CargoMsg.Cargo_VoucherNoCanTBeEmpty'))
          return false
        }
      }
      if (!this.voucher.fiscalPeriod && this.fiscalPeriodUuid) {
        this.voucher.fiscalPeriod = this.fpSelectDataProvider.find(p => p.uuid === this.fiscalPeriodUuid)
      }
      if (!this.voucher.fiscalPeriod) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VoucherPeriodCanTBeEmpty'))
        return false
      }
      if (!this.$refs.grid.validate(this.voucher)) {
        return false
      }
      return true
    },
    // 审核
    accept() {
      console.log('审核')
      const year = DateUtils.dateToStr(this.voucher.documentDate).getFullYear()
      const month = DateUtils.dateToStr(this.voucher.documentDate).getMonth() + 1
      if (VoucherUtils.checkVoucherDateClosing(year, month, this.fpSelectDataProvider)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SVSFPHBC'))
        return
      }
      this.voucher.verifier = this.$store.getters.userId
      this.voucher.state = FinanceInterfaceConstants.VOUCHER_AUDITED.code
      this.voucher.verifyDate = new Date()
      accountingDocumentApi.save(this.voucher).then(resp => {
        Object.assign(this.voucher, resp.data)
        this.$message.info(this.$t('CargoMsg.Cargo_AuditSuccessfully'))
      })
    },
    // 反审核
    reject() {
      console.log('反审核')
      const year = DateUtils.dateToStr(this.voucher.documentDate).getFullYear()
      const month = DateUtils.dateToStr(this.voucher.documentDate).getMonth() + 1
      if (VoucherUtils.checkVoucherDateClosing(year, month, this.fpSelectDataProvider)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SVSFPHBC'))
        return
      }
      this.voucher.verifier = 0
      this.voucher.verifyDate = null
      this.voucher.state = FinanceInterfaceConstants.VOUCHER_UNAUDITED.code
      accountingDocumentApi.save(this.voucher).then(resp => {
        Object.assign(this.voucher, resp.data)
        this.$message.info(this.$t('CargoMsg.Cargo_ReverseReviewedSuccessfully'))
      })
    },
    // 删除
    async delete() {
      console.log('删除')
      if (!this.voucher || !this.voucher.uuid) {
        return
      }
      if (this.voucher.closing) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VOPLCOCTBD'))
        return
      }
      const year = DateUtils.dateToStr(this.voucher.documentDate).getFullYear()
      const month = DateUtils.dateToStr(this.voucher.documentDate).getMonth() + 1
      if (VoucherUtils.checkVoucherDateClosing(year, month, this.fpSelectDataProvider)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SVSFPHBC'))
        return
      }

      if (this.voucher.state === FinanceInterfaceConstants.VOUCHER_AUDITED.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OnlyReviewedVouchersCanBeDeleted'))
        return
      }
      await this.$confirm(this.$t('CargoMsg.Cargo_STDTSVRJEWBDT'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      })
      const params = {}
      params.accountingKeys = [this.voucher.uuid]
      accountingDocumentApi.remove(params).then(resp => {
        this.$message.info(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
        // currentState = CREATESTATE;
        this.voucher = null
      })
      // accountingDocument.remove(new mx.rpc.Responder(deleteResultHandler, deleteFaultHandle));
    },
    // 打印
    print() {
      if (Number(cache.config.get('queryVoucherExcelExport')) === 1) {
        const variables = {}
        const uids = []
        uids.push(this.voucher.uuid)
        variables.data = JSON.stringify(uids)
        variables.excelExport = '1'
        variables.tenantId = this.$store.getters.tenantId
        variables.sessionId = getToken()
        variables.accountSetKey = this.accountSet.uuid
        variables.branchName = this.$store.getters.currentOffice.chineseName
        const serverUrl = URL.finance.accountingDocument.excelExportByAccountingDocumentSearch + '?sessionId=' + getToken()
        this.navigateToURL(serverUrl, variables)
        // ExportUtils.voucherExportToExcel(variables)
      } else {
        this.printHandler()
      }
    },
    async navigateToURL(URL, PARAMS) {
      const form = document.createElement('form')
      form.action = URL
      form.method = 'post'
      form.style.display = 'none'
      for (const key in PARAMS) {
        const opt = document.createElement('textarea')
        opt.name = key
        opt.value = PARAMS[key]
        form.appendChild(opt)
      }
      form.target = '_blank'
      document.body.appendChild(form)
      form.submit()
    },
    printHandler() {
      const uids = []
      uids.push(this.voucher.uuid)
      // TemplateSelectorWin.getInstance().showThisWin(null, "VOUCHERS", {"VOUCHERS_UUID": uids}, this);
      this.templateSelectorDialog.ctx = null
      this.templateSelectorDialog.category = 'VOUCHERS'
      this.templateSelectorDialog.data = { 'VOUCHERS_UUID': uids }
      this.templateSelectorDialog.visible = true
    },
    // 取消
    cancel() {
      console.log('取消')
      this.$emit('cancel')
    },
    fiscalPeriodLabelFun(data) {
      if (data) {
        return this.$t('FinanceManage.N0Year0Period', [data.year, data.month])
      }
      return ''
    },
    fiscalPeriodChangeHandler(val) {
      this.voucher.fiscalPeriod = this.fpSelectDataProvider.find(p => p.uuid === this.fiscalPeriodUuid)
    },
    changeWidthHandler() {
      let width = 1140
      if (this.$refs.grid && this.$refs.grid.showQuantity) width += this.$refs.grid.quantityColWidth
      if (this.$refs.grid && this.$refs.grid.showCurrency) width += this.$refs.grid.currencyColWidth
      this.formWidth = 'width:' + width + 'px'
    }
  }
}
</script>

<style lang="scss">
.accounting-document-form{
  width: 1140px;
  margin: 15px auto;
  &-title{
  display: flex;
    justify-content: space-between;
    .left{}
    .center{
      padding-left: 10px;
      flex: 1;
      font-size: 32px;
    }
    .left{}
   }
  &-table {
    padding-top: 15px;
  }
  &-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
}

</style>
